// src/oura/merchant/drawers/answersEmptied.ts
//
// Where focus goes once the Needs-you queue has nothing left. The drawer
// closes on Done after the last item, and the rows and the "Start answering"
// button that opened it have gone from the page as it is read again. A
// screen names a place that stays put (Decisions: the Questions for you
// card's head; Home: the Needs your reply card's head, else the page title):
// its handler moves focus there and says whether it did. The newest handler
// goes first.

import { useEffect } from "react";

const handlers = new Set<() => boolean>();

/** Register where focus goes when the drawer closes on Done with nothing left. */
export function useAnswersEmptiedFocus(handler: () => boolean): void {
    useEffect(() => {
        handlers.add(handler);
        return () => {
            handlers.delete(handler);
        };
    }, [handler]);
}

/** Runs the screen's handler; the element that now has focus, or null when no screen took it. */
export function focusAfterEmptied(): HTMLElement | null {
    for (const handler of Array.from(handlers).reverse()) {
        if (handler()) return document.activeElement instanceof HTMLElement ? document.activeElement : null;
    }
    return null;
}
